import { RootState } from '@app/store';
import { useTypedSelector } from '@app/store/hooks/useTypedSelector';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type GeoValue = 'inr' | 'ars';

interface IGeoState {
  value: GeoValue;
}

const GEO_VALUES: readonly GeoValue[] = ['inr', 'ars'];

const getStoredGeo = (): GeoValue => {
  try {
    const stored = localStorage.getItem('geo');
    return GEO_VALUES.includes(stored as GeoValue) ? (stored as GeoValue) : 'inr';
  } catch {
    return 'inr';
  }
};

const initialState: IGeoState = {
  value: getStoredGeo(),
};

const geoSlice = createSlice({
  name: 'geo',
  initialState,
  reducers: {
    setGeo: (state, action: PayloadAction<GeoValue>) => {
      try {
        localStorage.setItem('geo', action.payload);
      } catch {
        // Ignore storage errors (private mode, quota exceeded)
      }
      state.value = action.payload;
    },
  },
});

export const actions = geoSlice.actions;
export default geoSlice.reducer;

export const useGeoValue = (): GeoValue => useTypedSelector((state: RootState) => state.geo.value);

const ROLES_WITHOUT_GEO = ['provider'];

export const isGeoApplicable = (role: string | undefined) =>
  !ROLES_WITHOUT_GEO.includes(role ?? '');

export const isGeoFixed = (
  user: { type: string; is_internal: boolean } | null | undefined,
): boolean => {
  if (!user) return false;
  return user.type === 'operator' && !user.is_internal;
};
